import { handleResponse, handleError, apiUrl } from "./apiUtils";

const baseUrl = apiUrl + "food";

export async function getAllFood() {
    try {
        let result = await fetch(baseUrl);
        return handleResponse(result);
    } catch (error) {
        handleError(error);
    }
}

export async function getFoodList() {
    try {
        let result = await fetch(`${baseUrl}/getFoodList`);
        return handleResponse(result);
    } catch (error) {
        handleError(error);
    }
}

export async function getFood(foodId) {
    try {
        let result = await fetch(`${baseUrl}/${foodId}`);
        return handleResponse(result);
    } catch (error) {
        handleError(error);
    }
}

export async function updateFood(foodId, food) {
    try {
        let result = await fetch(`${baseUrl}/${foodId}`, {
            method: "PUT",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(food)
        });
        return handleResponse(result);
    } catch (error) {
        handleError(error);
    }
}

export async function addFood(food) {
    try {
        let result = await fetch(baseUrl, {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(food)
        });
        return handleResponse(result);
    } catch (error) {
        handleError(error);
    }
}

export async function deleteFood(foodId) {
    try {
        let result = await fetch(`${baseUrl}/${foodId}`, {
            method: "DELETE",
            headers: { "content-type": "application/json" }
        });
        return handleResponse(result);
    } catch (error) {
        handleError(error);
    }
}
